export const getCurrentEnv = (): string => {
  const currentHost = `${window.location.origin}/`;

  if (currentHost === process.env.REACT_APP_PROD_HOST) return "PROD";
  if (currentHost === process.env.REACT_APP_STAGING_HOST) return "STAGING";
  if (currentHost === process.env.REACT_APP_QA_HOST) return "QA";
  if (currentHost === process.env.REACT_APP_DEV_HOST) return "DEV";

  return "LOCAL";
};
